module.exports = __webpack_public_path__ + "static/media/bankcard.0a91d792.png";